import { FormArray, FormGroup } from "@angular/forms";
import { formatRange } from "@fullcalendar/core";
import { CategoryElementDTO } from "src/app/models/Categories/categoryElementDTO";

export class CategoriesAndPropsUtils {
  // loaded locale
  private static locale: string = localStorage.getItem("locale");

  static setFormCategories(
    categories: { [key: string]: string }[]
  ): { categoryCode: string; code: string }[] {
    const formCategories = categories.reduce((acc, cur) => {
      const [categoryCode] = Object.keys(cur);
      const value = cur[categoryCode];
      if (!value) {
        return acc;
      }
      return [...acc, { categoryCode, code: value }];
    }, []);
    return formCategories;
  }

  static setFormProperties(
    properties: { [key: string]: string | number | boolean | object }[]
  ): { code: string; value: string | number | boolean }[] {
    const formProperties = properties.reduce((acc, cur) => {
      const [code] = Object.keys(cur);
      const value = cur[code];
      if (value === null || value === undefined || value === "") {
        return acc;
      }
      return [
        ...acc,
        {
          code,
          value: value["_d"] ? value["_d"].toISOString() : value,
        },
      ];
    }, []);
    return formProperties;
  }

  static loadFormCategories(
    categorieFlat: any,
    loadedCategories: any[],
    formInput: FormArray
  ) {
    const values = [];
    formInput.reset();
    if (categorieFlat && Object.keys(categorieFlat).length > 0) {
      for (const key in categorieFlat) {
        if (categorieFlat.hasOwnProperty(key)) {
          let value: any;
          let searchValue =
            categorieFlat[key].length > 0
              ? categorieFlat[key][0].categoryCode
              : "";

          const idx = loadedCategories.findIndex(
            (loadedCat) => loadedCat.categoryCode === searchValue
          );
          if (searchValue !== "") {
            if (idx >= 0) {
              value =
                loadedCategories[idx].categoryCode +
                ":" +
                loadedCategories[idx].code;

              values.push({
                code: value,
                categoryCode: searchValue,
              });
            } else {
              values.push();
            }
          }
        }
      }
    }
    setTimeout(() => {
      (formInput.controls[0] as FormGroup).controls.code.patchValue({
        code: values[0].code,
      });
    });
  }

  static loadFormProperties(
    props: any[],
    loadedProps: any[],
    formInput: FormArray
  ) {
    const values = [];
    formInput.reset();
    if (props && Object.keys(props).length > 0) {
      for (const key in props) {
        if (props.hasOwnProperty(key)) {
          let value: any = "";
          const idx = loadedProps.findIndex(
            (loadedProp) => loadedProp.code === props[key].code
          );
          if (idx >= 0) {
            if (props[key].dataTypeCode === "DATE") {
              // const date = new Date(loadedProps[idx].value);
              if (isNaN(Date.parse(loadedProps[idx].value))) {
                value = null;
              } else {
                value = new Date(loadedProps[idx].value);
              }
            } else if (props[key].dataTypeCode === "BOOLEAN") {
              if (loadedProps[idx]?.value?.length > 0) {
                value = [loadedProps[idx]?.value];
              } else {
                value = null;
              }
            } else {
              value = loadedProps[idx].value;
            }
          }
          values.push({
            propValue: value,
            code: props[key].code,
          });
        }
      }
    }

    formInput.patchValue(values);
  }

  static buildProperties(props: any[]): any[] {
    if (props && props?.length > 0) {
      const propList = props.map((prop, idx) => {
        if (
          prop?.propValue &&
          (prop?.propValue?.toString()?.length
            ? prop?.propValue?.toString()?.length > 0
            : prop?.propValue?.length > 0)
        ) {
          return {
            code: prop && prop?.code !== null ? prop?.code : undefined, // this.propertiesList[idx].code,
            value:
              Array.isArray(prop?.propValue) && prop?.propValue?.length > 0
                ? prop.propValue[0]
                : typeof prop?.propValue === "object"
                ? prop?.propValue?.toDateString()
                : prop?.propValue?.toString(),
          };
        }
      });
      return propList?.length > 0 ? propList : [];
    }
  }

  static buildCategories(cats: any[]): any[] {
    if (cats && cats?.length > 0) {
      return cats.map((cat, idx) => {
        if (
          cat &&
          cat.code &&
          cat.code !== null &&
          cat?.code[0] &&
          cat?.code[0] !== ""
        ) {
          return {
            code: cat?.code[0].split(":")[1],
            categoryCode: cat?.code[0].split(":")[0],
          };
        } else {
          return {
            code: "",
            categoryCode: "",
          };
        }
      });
    }
  }

  static buildCategoriesFlat(
    catElements: CategoryElementDTO[],
    code: string,
    catDesc: string,
    catFlatList: any[]
  ) {
    catElements.forEach((catElem) => {
      if (catElem.elements && catElem.elements.length > 0) {
        this.addCatFlat(
          code,
          catElem,
          catDesc +
            ":" +
            (catElem.detailedDescription[this.locale]
              ? catElem.detailedDescription[this.locale]
              : catElem.description),
          catFlatList
        );
        this.buildCategoriesFlat(
          catElem.elements,
          code + ":" + catElem.code,
          catDesc +
            ":" +
            (catElem.detailedDescription[this.locale]
              ? catElem.detailedDescription[this.locale]
              : catElem.description),
          catFlatList
        );
      } else {
        this.addCatFlat(code, catElem, catDesc, catFlatList);
      }
      return;
    });
  }
  private static addCatFlat(
    grpCode: string,
    catElem: CategoryElementDTO,
    catDesc: string,
    catFlatList: any[]
  ) {
    if (catDesc !== undefined && !catDesc.includes("undefined")) {
      const catCode = grpCode.split(":")[0];

      let elements: any[] = catFlatList[catCode];

      if (elements.findIndex((item) => item.itemCode === catElem.code) < 0) {
        elements = elements.concat({
          groupCode: grpCode,
          groupCodeDesc: catDesc !== undefined ? catDesc : "a",
          itemCode: catCode + ":" + catElem.code,
          itemDesc: catElem.detailedDescription[this.locale]
            ? catElem.detailedDescription[this.locale]
            : catElem.description,
          categoryCode: catCode,
        });
        catFlatList[catCode] = elements;
      }
    }
  }
}
